export default {"src":"/_next/static/media/Reports_n_Dashboard.91cc53e3.svg","height":31,"width":34};